/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 24/05/22
 */

import { and, ArrayLayoutProps, isObjectArray, RankedTester, rankWith, uiTypeIs } from '@jsonforms/core';
import merge from 'lodash/merge';
import React from 'react';
import { Box } from '@chakra-ui/react';
import { withNamedJsonFormsArrayLayoutProps } from '../../utils/withNamedJsonFormsHOC';
import ChakraListWithDetailLayoutToolBar from './ChakraListWithDetailLayoutToolBar';
import ChakraListWithDetailItems from './ChakraListWithDetailItems';
import { omit } from 'lodash';
import { namedMemo } from '@/utils/namedMemo';

export const ChakraListWithDetailRenderer = namedMemo('ChakraListWithDetailRenderer', (props: ArrayLayoutProps) => {
    const { uischema, schema, path, enabled, label, addItem, config, errors } = props;
    const appliedUiSchemaOptions = merge({}, config, uischema.options);
    const readonly = appliedUiSchemaOptions.readonly;

    const itemsProps = omit(props, 'data');
    const hideListControls =
        appliedUiSchemaOptions.editHideListControls &&
        (appliedUiSchemaOptions.mode === 'edit' || appliedUiSchemaOptions.mode === 'view');
    return (
        <Box>
            <ChakraListWithDetailLayoutToolBar
                label={label}
                path={path}
                schema={schema}
                uischema={uischema}
                addItem={addItem}
                enabled={enabled}
                isReadonly={readonly}
                errors={errors}
            />
            <ChakraListWithDetailItems {...itemsProps} hideListControl={hideListControls} />
        </Box>
    );
});

export const chakraListWithDetailTester: RankedTester = rankWith(4, and(uiTypeIs('ListWithDetail'), isObjectArray));

export default withNamedJsonFormsArrayLayoutProps(ChakraListWithDetailRenderer);
